import script from "./AppointmentCancelRequestedDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentCancelRequestedDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentCancelRequestedDetailPage.vue?vue&type=style&index=0&id=4c4b8006&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c4b8006"]])

export default __exports__